import { IVersionCheckTarget } from '@vattenfall/wind-common-fe';

const DEV_CHECK_FLAG_KEY = 'WITHOST_ENABLE_VERSION_CHECK_DEV';

const WORKFLOWS_APP_URL = process.env.REACT_APP_WORKFLOWS_APP_URL;
const SNAGS_APP_URL = process.env.REACT_APP_SNAGS_APP_URL;

const VERSION_CHECK_TARGETS: IVersionCheckTarget[] = [
  { storageKey: 'WITHOST_BUILD_TIMESTAMP', probeUrl: `${window.location.origin}/index.html` },
  ...(WORKFLOWS_APP_URL
    ? [{ storageKey: 'WITWORKFLOWS_BUILD_TIMESTAMP', probeUrl: `${WORKFLOWS_APP_URL}/remoteEntry.js` }]
    : []),
  ...(SNAGS_APP_URL ? [{ storageKey: 'SNAGS_BUILD_TIMESTAMP', probeUrl: `${SNAGS_APP_URL}/snagsEntry.js` }] : []),
];

const IS_VERSION_CHECK_ENABLED =
  process.env.NODE_ENV !== 'development' || localStorage.getItem(DEV_CHECK_FLAG_KEY) === 'true';

export { VERSION_CHECK_TARGETS, IS_VERSION_CHECK_ENABLED };
